function Logout() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 2 22 20" 
      fill="currentColor"
      > 
      <path xmlns="http://www.w3.org/2000/svg" d="M19.1923 21C19.6974 21 20.125 20.825 20.475 20.475C20.825 20.125 21 19.6974 21 19.1923V5.8077C21 5.30257 20.825 4.875 20.475 4.525C20.125 4.175 19.6974 4 19.1923 4H12.4904V5.49998H19.1923C19.2692 5.49998 19.3397 5.53203 19.4038 5.59613C19.4679 5.66024 19.5 5.73077 19.5 5.8077V19.1923C19.5 19.2692 19.4679 19.3397 19.4038 19.4038C19.3397 19.4679 19.2692 19.5 19.1923 19.5H12.4904V21H19.1923ZM8.2692 16.7692L9.30763 15.6846L6.87303 13.25H15.4038V11.75H6.87303L9.30763 9.31538L8.2692 8.2308L4 12.5L8.2692 16.7692Z"/>
    </svg>
  );
}

export default Logout;
